var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "facet-template",
    {
      attrs: { "show-clear-link": _vm.isFiltered, "facet-name": "dealBadges" },
      on: { clear: _vm.clearDealBadges }
    },
    [
      _c("span", { attrs: { slot: "facetLabel" }, slot: "facetLabel" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("component.facets.dealBadges")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "facetBody" }, slot: "facetBody" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 p-0" },
              [
                _c(
                  "b-form-group",
                  { staticClass: "m-0" },
                  [
                    _c(
                      "b-form-checkbox-group",
                      {
                        attrs: {
                          id: "badges",
                          stacked: "",
                          plain: "",
                          name: "badges",
                          "aria-label": "Individual Badges"
                        },
                        model: {
                          value: _vm.selectedDealBadges,
                          callback: function($$v) {
                            _vm.selectedDealBadges = $$v
                          },
                          expression: "selectedDealBadges"
                        }
                      },
                      _vm._l(_vm.availableDealBadgesOptions, function(badge) {
                        return _c(
                          "b-form-checkbox",
                          {
                            key: badge.id,
                            staticClass: "mb-2",
                            attrs: { value: badge.id }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(badge.name) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }